import { Navigate, useParams } from 'react-router-dom'

const MapDetailPageDeprecated = () => {
  const params = useParams()

  return <Navigate to={`/landing/${params.communityId}`} replace />
}

export default MapDetailPageDeprecated
